/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents status of the reports like NEW, PENDING_APPROVAL, PUBLISHED etc.,
 * Note: doesn't capture all status, will keep adding when required.
 * PUBLISHED - Report has been published to external users by internal users or vice versa.
 * VALIDATION_COMPLETED - Report has been validated both internally and by the client.
 * VALIDATION_PENDING - Report has been validated internally and is waiting for client validations to be performed.
 * VALIDATION_FAILED - Report validation has failed either at the client or internally.
 * APPROVAL_CREATED - Approval document related to the report has been created.
 * APPROVAL_PENDING - Approval related to the report is in a pending state.
 * APPROVAL_COMPLETED - Approval related to the report has been approved.
 * INGESTION_PENDING - Report is being ingested at the client end.
 * INGESTION_COMPLETED - Report has been successfully ingested at the client end.
 * INGESTION_FAILED - Report ingestion has failed at the client end.
 * <\/code><\/pre>
 **/
export var ReportStatus;
(function (ReportStatus) {
    ReportStatus["PUBLISHED"] = "PUBLISHED";
    ReportStatus["PENDING"] = "PENDING";
    ReportStatus["VALIDATION_COMPLETED"] = "VALIDATION_COMPLETED";
    ReportStatus["VALIDATION_PENDING"] = "VALIDATION_PENDING";
    ReportStatus["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    ReportStatus["APPROVAL_CREATED"] = "APPROVAL_CREATED";
    ReportStatus["APPROVAL_PENDING"] = "APPROVAL_PENDING";
    ReportStatus["APPROVAL_COMPLETED"] = "APPROVAL_COMPLETED";
    ReportStatus["INGESTION_PENDING"] = "INGESTION_PENDING";
    ReportStatus["INGESTION_COMPLETED"] = "INGESTION_COMPLETED";
    ReportStatus["INGESTION_FAILED"] = "INGESTION_FAILED";
    ReportStatus["APPROVAL_REJECTED"] = "APPROVAL_REJECTED";
})(ReportStatus || (ReportStatus = {}));
